module.exports = __webpack_public_path__ + "img/asia-insurance-logo-white.e41b8df6.png";